import { empApi } from "./client";

// Danh sách hợp đồng mua bán -> { items, pagination }
export const getSalesContractListApi = (params) => empApi.get("/salesContract/app", params);

// Chi tiết HĐMB
export const getSalesContractByIdApi = (id) => empApi.get(`/salesContract/app/${id}`);
